import { useCallback, useEffect, useState } from 'react';
import { getCustomerOperations } from '@/features/customers/api';
import type { CustomerOperations } from '@/features/customers/types';

/// Apart from the account, like the timeline: if this fails, the account can still be read and
/// corrected.
export function useCustomerOperations(token: string | null, customerId: string) {
  const [operations, setOperations] = useState<CustomerOperations | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!token) {
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    getCustomerOperations(token, customerId)
      .then((loaded) => {
        if (!cancelled) {
          setOperations(loaded);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError('No pudimos cargar las operaciones. Revisá la conexión e intentá de nuevo.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token, customerId, version]);

  const reload = useCallback(() => setVersion((current) => current + 1), []);

  return { operations, isLoading, error, reload };
}
